const func = $target => {
	$target
		.find('a')
		.on('touchstart', function(e) {
			if (!$(this).hasClass('linkEnabled')) {
				e.stopPropagation();
				$target.find('a').removeClass('linkEnabled');
				//$(this).addClass('linkEnabled');
			}
		})
		.on('touchend', function(e) {
			if (!$(this).hasClass('linkEnabled')) {
				e.preventDefault();
				$(this).addClass('linkEnabled');
			}
		});
};

export default func;
